import ko from 'knockout';
import { KoSchema } from '@bingads-webui/ko-schema';

export default class ViewModel {
  constructor({ deps, currentOperand = '' } = {}) {
    this.sampleOffers = ko.observableArray();
    this.sampleCount = ko.observable();

    this.showLimitExceededWarning = ko.observable(false);
    this.hasOffer = ko.computed(() => this.sampleCount() > 0);
    this.currentOperand = ko.observable(currentOperand);

    this.offerDescription = ko.computed(() => {
      const sampleCount = this.sampleCount();

      if (!this.hasOffer()) {
        return deps.i18n.getString('ProductGroupsGrid_NoSampleOfferDescription');
      } else if (sampleCount === 1) {
        return deps.i18n.getString('ProductGroupsGrid_SingularSampleOfferDescription', { sampleCount });
      }
      return deps.i18n.getString('ProductGroupsGrid_PluralSampleOfferDescription', { sampleCount });
    });

    this.updateSample = (data) => {
      this.sampleOffers(data);
      this.sampleCount(data.totalCount);
    };

    KoSchema(this);
  }
}
